import { CANT_ACCESS_EMPLOYEE, CLEAN, CONFIRMING_MOVEMENT, CONFIRM_ACCESS, ERROR_ACCESS, ERROR_SERVER, GET_ACCESS_CONTRACTORS, SET_EMPLOYEE, SET_ACCESS_WITH, SET_STEP, SET_TYPE, SET_VISIT, CONFIRM_EXIT } from "./types";

const AccessReducer = (state, action) => {
    const { type, payload } = action;
    switch (type) {
        case ERROR_SERVER:
            return {
                ...state,
                error: true,
                message: payload,
                isFetching: false,
            }
        case SET_TYPE:
            return {
                ...state,
                type: payload
            }
        case GET_ACCESS_CONTRACTORS:
            return {
                ...state,
                error: false,
                message: '',
                isFetching: false,
                contractors: payload,
                step: 'CONTRACTOR_SELECTABLE',
            }
        case SET_EMPLOYEE:
            return {
                ...state,
                employee: payload,
                visit: null
            }
        case SET_VISIT:
            return {
                ...state,
                visit: payload,
                employee: null,
            }
        case CANT_ACCESS_EMPLOYEE:
            return {
                ...state,
                employee: payload.employee,
                step: 'EMPLOYEE_NO_ACCESS',
                type: 'ACCESS',
                message: payload.message,
            }
        case CLEAN:
            return {
                ...state,
                error: false,
                message: '',
                isFetching: true,
                contractors: [],
                employee: null,
                visit: null,
                step: '',
                type: '',
                accessWithCar: false,
                confirmingMovement: false,
                errorType: ''
            }
        case SET_STEP:
            return {
                ...state,
                step: payload
            }
        case SET_ACCESS_WITH:
            return {
                ...state,
                ...payload
            }
        case CONFIRM_ACCESS:
            return {
                ...state,
                step: 'SUCCESS_MOVEMENT',
                confirmingMovement: false,
            }
        case CONFIRM_EXIT:
            return {
                ...state,
                step: 'SUCCESS_MOVEMENT',
                confirmingMovement: false,
            }
        case ERROR_ACCESS:
            return {
                ...state,
                step: 'ERROR_MOVEMENT',
                errorType: payload,
                confirmingMovement: false,
            }
        case CONFIRMING_MOVEMENT:
            return {
                ...state,
                confirmingMovement: true,
            }
        default:
            return state;
    }
}

export default AccessReducer